var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5279_18381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.793 46.7672C140.793 45.6939 140.563 44.7454 140.099 43.9314C139.643 43.131 138.96 42.4601 138.044 41.9296C130.483 37.5699 122.914 33.2234 115.356 28.8592C113.318 27.6828 111.342 27.7256 109.32 28.919C106.31 30.6939 91.2422 39.3265 86.7522 41.9272C84.9031 42.9976 84.0033 44.6359 84.0029 46.7652C84 55.533 84.0029 64.3005 84 73.0685C84 74.1183 84.2202 75.0483 84.664 75.8501C85.1202 76.6748 85.8127 77.3641 86.7498 77.9065C91.24 80.5072 106.31 89.1392 109.319 90.9145C111.342 92.1085 113.318 92.1512 115.356 90.9743C122.915 86.6099 130.484 82.2636 138.046 77.9039C138.984 77.3616 139.676 76.6719 140.132 75.8479C140.575 75.0461 140.796 74.1161 140.796 73.0661C140.796 73.0661 140.796 55.5352 140.793 46.7672Z",
    fill: "#A179DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.485 59.8315L84.6641 75.8502C85.1203 76.6749 85.8127 77.3642 86.7498 77.9067C91.2401 80.5073 106.31 89.1393 109.319 90.9147C111.342 92.1087 113.318 92.1513 115.357 90.9744C122.915 86.61 130.484 82.2638 138.047 77.904C138.984 77.3618 139.676 76.672 140.132 75.848L112.485 59.8315Z",
    fill: "#280068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.793 46.7674C140.793 45.6941 140.563 44.7456 140.099 43.9316L112.485 59.8316L140.132 75.8481C140.575 75.0463 140.796 74.1163 140.796 73.0663C140.796 73.0663 140.796 55.5354 140.793 46.7674Z",
    fill: "#390091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.865 53.8433V56.8374H131.859V53.8433H133.356V56.8374H136.35V58.3345H133.356V61.3286H136.35V62.8257H133.356V65.8199H131.859V62.8257H128.865V65.8199H127.368V62.8257H124.374V61.3286H127.368V58.3345H124.374V56.8374H127.368V53.8433H128.865ZM131.859 58.3345H128.865V61.3286H131.859V58.3345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.546 38.8057C120.356 38.8057 127.174 43.0471 130.826 49.3515L130.791 49.2908L121.602 54.5815C119.792 51.5163 116.473 49.4477 112.666 49.4051L112.546 49.4044C106.74 49.4044 102.033 54.111 102.033 59.9167C102.033 61.8152 102.54 63.5949 103.42 65.1321C105.232 68.2955 108.638 70.4291 112.546 70.4291C116.478 70.4291 119.903 68.2684 121.706 65.0711L121.662 65.1479L130.837 70.463C127.225 76.714 120.5 80.9423 112.781 81.0266L112.546 81.0279C104.711 81.0279 97.8735 76.7604 94.2306 70.4226C92.4521 67.3287 91.4346 63.7417 91.4346 59.9167C91.4346 48.2575 100.886 38.8057 112.546 38.8057Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5279_18381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.8889,
    height: 64,
    fill: "white",
    transform: "translate(84 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.ed69225bdf55a8479f0fcf94627e6322.svg";
export { ForwardRef as ReactComponent };